import { render, staticRenderFns } from "./ot-project-claims-index.vue?vue&type=template&id=b5aab432&scoped=true&"
import script from "./ot-project-claims-index.vue?vue&type=script&lang=ts&"
export * from "./ot-project-claims-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-claims-index.vue?vue&type=style&index=0&id=b5aab432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aab432",
  null
  
)

export default component.exports